function predictiveSearch(event) {
  const query = (event.target.value || '').trim();
  if (query.length < 3) {
    // nascondi risultati se query troppo corta
    searchResults.style.display = 'none';
    target.innerHTML = '';
    return;
  }

  const fetchData = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' }
  };

  // NB: encodeURIComponent per evitare problemi con spazi / caratteri speciali
  const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=10`;

  fetch(url, fetchData)
    .then(resp => resp.json())
    .then(res => {
      const raw = (res && res.resources && res.resources.results && res.resources.results.products) || [];

      // 🔒 FILTRO: tieni SOLO prodotti davvero disponibili e pubblicati
      //  - available: almeno una variante disponibile
      //  - url / online_store_url: ha una pagina attiva sullo store
      //  - (opzionale) variants.some(v.available) per ulteriore sicurezza
      const products = raw.filter(p => {
        const isAvailable = !!p?.available || (Array.isArray(p?.variants) && p.variants.some(v => v?.available));
        const hasUrl = !!p?.url || !!p?.online_store_url;
        return isAvailable && hasUrl;
      });

      // se non c'è nulla da mostrare, chiudi il pannello
      if (!products.length) {
        target.innerHTML = '';
        searchResults.style.display = 'none';
        return;
      }

      // Template prodotto
      const template = `
        <a href="%%url%%" class="search__result-product">
          <div class="wrapper">
            <img src="%%featuredImage%%" alt="%%alt%%" loading="lazy">
          </div>
          <div class="content">
            <p class="vendor">%%vendor%%</p>
            <p class="title">%%title%%</p>
            <p class="price">€ %%price_min%%</p>
          </div>
        </a>`.trim();

      // pulisci e mostra la griglia
      target.innerHTML = '';
      searchResults.style.display = 'grid';

      // render prodotti filtrati (max 10, o quello che vuoi)
      products.slice(0, 10).forEach(p => {
        const img = p?.featured_image?.url || p?.images?.[0]?.url || '';
        // usa price_min se disponibile; fallback su price_max
        const priceNumber = (typeof p?.price_min === 'number' ? p.price_min : p?.price_max) || 0;
        const priceFormatted = Number(priceNumber).toFixed(2);

        let item = template
          .replace('%%vendor%%', (p.vendor || '').toString())
          .replaceAll('%%title%%', (p.title || '').toString())
          .replace('%%alt%%', (p.title || '').toString())
          .replace('%%featuredImage%%', img)
          .replace('%%price_min%%', priceFormatted)
          .replace('%%url%%', (p.url || p.online_store_url || '#'));

        target.insertAdjacentHTML('beforeend', item);
      });
    })
    .catch(() => {
      // in caso di errore, nascondi i risultati
      target.innerHTML = '';
      searchResults.style.display = 'none';
    });
}
